<template>
  <section id="explore_area" class="section_padding">
    <div class="container">
      <!-- Section Heading -->
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="section_heading_center">
            <h2>38 hotel found</h2>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3">
          <div class="left_side_search_area">
            <div class="left_side_search_boxed">
              <div class="left_side_search_heading">
                <h5>Filter by price</h5>
              </div>
              <div class="filter-price">
                <Slider v-model="value" class="apply" />
              </div>
              <button class="apply" type="button">Apply</button>
            </div>
            <div class="left_side_search_boxed">
              <div class="left_side_search_heading">
                <h5>Filter by Review</h5>
              </div>
              <div class="filter_review">
                <form class="review_star">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_theme"></i>
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault1"
                    />
                    <label class="form-check-label" for="flexCheckDefault1">
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_asse"></i>
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault2"
                    />
                    <label class="form-check-label" for="flexCheckDefault2">
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_asse"></i>
                      <i class="fas fa-star color_asse"></i>
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault3"
                    />
                    <label class="form-check-label" for="flexCheckDefault3">
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_asse"></i>
                      <i class="fas fa-star color_asse"></i>
                      <i class="fas fa-star color_asse"></i>
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault5"
                    />
                    <label class="form-check-label" for="flexCheckDefault5">
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_asse"></i>
                      <i class="fas fa-star color_asse"></i>
                      <i class="fas fa-star color_asse"></i>
                      <i class="fas fa-star color_asse"></i>
                    </label>
                  </div>
                </form>
              </div>
            </div>
            <div class="left_side_search_boxed">
              <div class="left_side_search_heading">
                <h5>Filter by hotel star</h5>
              </div>
              <div class="filter_review">
                <form class="review_star">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefaulta"
                    />
                    <label class="form-check-label" for="flexCheckDefaulta">
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_theme"></i>
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefaulf21"
                    />
                    <label class="form-check-label" for="flexCheckDefaulf21">
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_asse"></i>
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefaultf3"
                    />
                    <label class="form-check-label" for="flexCheckDefaultf3">
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_asse"></i>
                      <i class="fas fa-star color_asse"></i>
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefaultf4"
                    />
                    <label class="form-check-label" for="flexCheckDefaultf4">
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_asse"></i>
                      <i class="fas fa-star color_asse"></i>
                      <i class="fas fa-star color_asse"></i>
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefaultf5"
                    />
                    <label class="form-check-label" for="flexCheckDefaultf5">
                      <i class="fas fa-star color_theme"></i>
                      <i class="fas fa-star color_asse"></i>
                      <i class="fas fa-star color_asse"></i>
                      <i class="fas fa-star color_asse"></i>
                      <i class="fas fa-star color_asse"></i>
                    </label>
                  </div>
                </form>
              </div>
            </div>
            <div class="left_side_search_boxed">
              <div class="left_side_search_heading">
                <h5>Facilities</h5>
              </div>
              <div class="tour_search_type">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckDefaultf1"
                  />
                  <label class="form-check-label" for="flexCheckDefaultf1">
                    <span class="area_flex_one">
                      <span>Wake-up call</span>
                      <span>20</span>
                    </span>
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckDefaultf2"
                  />
                  <label class="form-check-label" for="flexCheckDefaultf2">
                    <span class="area_flex_one">
                      <span>Flat TV</span>
                      <span>14</span>
                    </span>
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckDefaultaf3"
                  />
                  <label class="form-check-label" for="flexCheckDefaultaf3">
                    <span class="area_flex_one">
                      <span>Vehicle service</span>
                      <span>30</span>
                    </span>
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckDefaultaf4"
                  />
                  <label class="form-check-label" for="flexCheckDefaultaf4">
                    <span class="area_flex_one">
                      <span>Guide service</span>
                      <span>22</span>
                    </span>
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckDefaultaf5"
                  />
                  <label class="form-check-label" for="flexCheckDefaultaf5">
                    <span class="area_flex_one">
                      <span>Internet, Wi-fi</span>
                      <span>41</span>
                    </span>
                  </label>
                </div>
              </div>
            </div>
            <div class="left_side_search_boxed">
              <div class="left_side_search_heading">
                <h5>Hotel service</h5>
              </div>
              <div class="tour_search_type">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckDefaultt1"
                  />
                  <label class="form-check-label" for="flexCheckDefaultt1">
                    <span class="area_flex_one">
                      <span>Gymnasium</span>
                      <span>20</span>
                    </span>
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckDefaultt2"
                  />
                  <label class="form-check-label" for="flexCheckDefaultt2">
                    <span class="area_flex_one">
                      <span>Mountain Bike</span>
                      <span>14</span>
                    </span>
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckDefaultt3"
                  />
                  <label class="form-check-label" for="flexCheckDefaultt3">
                    <span class="area_flex_one">
                      <span>Wifi</span>
                      <span>62</span>
                    </span>
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckDefaultt4"
                  />
                  <label class="form-check-label" for="flexCheckDefaultt4">
                    <span class="area_flex_one">
                      <span>Aerobics Room</span>
                      <span>08</span>
                    </span>
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckDefaultt5"
                  />
                  <label class="form-check-label" for="flexCheckDefaultt5">
                    <span class="area_flex_one">
                      <span>Golf Cages</span>
                      <span>12</span>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-9">
          <div class="row">
            <div
              v-for="(hotelInfo, index) in items"
              class="col-lg-4 col-md-6 col-sm-6 col-12"
            >
              <div class="theme_common_box_two img_hover">
                <div class="theme_two_box_img">
                  <router-link to="/tour-details">
                    <img
                      :src="
                        require(`@/assets/img/tab-img/${hotelInfo.tourImage}.png`)
                      "
                      alt="{{ hotelInfo.altText }}"
                    />
                  </router-link>
                  <p>
                    <i class="fas fa-map-marker-alt"></i
                    >{{ hotelInfo.location }}
                  </p>
                </div>
                <div class="theme_two_box_content">
                  <h4>
                    <router-link to="/tour-details">{{
                      hotelInfo.tourTitle
                    }}</router-link>
                  </h4>
                  <p>
                    <span class="review_rating">{{
                      hotelInfo.reviewRating
                    }}</span>
                    <span class="review_count"
                      >({{ hotelInfo.reviewCount }})</span
                    >
                  </p>
                  <h3>
                    {{ hotelInfo.price }} <span>{{ hotelInfo.startForm }}</span>
                  </h3>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="pagination_area">
                <ul class="pagination">
                  <li class="page-item">
                    <a class="page-link" href="#" aria-label="Previous">
                      <span aria-hidden="true">&laquo;</span>
                      <span class="sr-only">Previous</span>
                    </a>
                  </li>
                  <li class="page-item"><a class="page-link" href="#">1</a></li>
                  <li class="page-item"><a class="page-link" href="#">2</a></li>
                  <li class="page-item"><a class="page-link" href="#">3</a></li>
                  <li class="page-item">
                    <a class="page-link" href="#" aria-label="Next">
                      <span aria-hidden="true">&raquo;</span>
                      <span class="sr-only">Next</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Slider from "@vueform/slider";
import data from "../../data";

export default {
  name: "SearchResult",
  components: {
    Slider,
  },
  data() {
    return {
      value: [0, 75],
      items: [],
    };
  },
  mounted() {
    this.items = data.hotelData;
  },
};
</script>
<style src="@vueform/slider/themes/default.css"></style>
